









import { Component, Vue, Prop } from 'vue-property-decorator';
import TemplateModal from '@/components/TemplateModal/TemplateModal.vue';
import eventBus from '@/utils/eventBus';
import APIService from '@/api';
import ManagerService from '@/api/ManagerService';

@Component({
  components: {
    TemplateModal
  }
})
export default class LostAccessModal extends Vue {
  @Prop({ required: false }) data!: any;
  service = new ManagerService();

  get text() {
    let name = 'this business';
    const businessInfo = this.$store.getters['business/getBusinessInfo'];

    if (businessInfo && businessInfo.business) {
      name = businessInfo.business.name;
    }

    return `Your access to ${name} is no longer available.`;
  }

  async lostAccess() {
    this.$showLoaderWithLocker();

    const connectRes = await this.service.connect(this.data.id);
    this.service.setCredentials(connectRes.data.access_token);
    window.location.reload();
  }
}
